import { render } from "./PhotographyIcon.vue?vue&type=template&id=29ed4d0c"
import script from "./PhotographyIcon.vue?vue&type=script&lang=js"
export * from "./PhotographyIcon.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__